import React from 'react';

import { useRecoilState, useSetRecoilState } from 'recoil';

import Icon from 'components/shared/Icon/Icon';

import {
  generalChatActivePromptConversationsState,
  generalChatActivePromptIdState,
  generalChatGenerating,
  generalChatIdState,
  generalChatLoading
} from './state';

export const ChatHeader = ({ title, profileAvatar, isExpanded, toggleSize, toggleModal }) => {
  const setIsLoading = useSetRecoilState(generalChatLoading);
  const [isGenerating, setIsGenerating] = useRecoilState(generalChatGenerating);
  const setIntelligenceChatId = useSetRecoilState(generalChatIdState);
  const setActivePromptId = useSetRecoilState(generalChatActivePromptIdState);
  const setActivePromptConversations = useSetRecoilState(generalChatActivePromptConversationsState);

  const addNewPrompt = () => {
    if (!!isGenerating) {
      setIsLoading(false);
      setIsGenerating(false);

      // stopResponseGeneration({ intelligenceChatId });
    }
    setActivePromptId(null);
    setActivePromptConversations(null);
    setIntelligenceChatId(null);
  };
  return (
    <div className="flex items-center justify-between border-b p-4">
      <div className="flex items-center space-x-3">
        {profileAvatar && <img src={profileAvatar} alt="Avatar" className="h-8 w-8 rounded-full" />}
        <div className="flex gap-2">
          <h2 className="text-lg font-semibold">{title || 'Myscribe AI chat'}</h2>
          {!isExpanded && (
            <Icon icon="edit-4-linear" size={20} color="primary" onClick={addNewPrompt} />
          )}
        </div>
      </div>
      <div className="flex space-x-2">
        <button
          onClick={toggleSize}
          className="p-2 text-gray-600 hover:text-blue-600"
          aria-label={isExpanded ? 'Collapse' : 'Expand'}>
          {isExpanded ? (
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14" />
            </svg>
          ) : (
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
              />
            </svg>
          )}
        </button>
        <button
          onClick={toggleModal}
          className="p-2 text-gray-600 hover:text-red-600"
          aria-label="Close">
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
